import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useMedia } from '@/composables/useMedia';
import { RESPONSIVE_BREAKPOINTS } from '@/consts/responsiveBreakpoints.const';
import { ROUTES_WITH_MOBILE_HEADER } from '@/consts/routes.const';

export const useHideMobileHeader = () => {
  const isMobile = useMedia(RESPONSIVE_BREAKPOINTS.tabletPortrait);
  const route = useRoute();

  const routeWithoutMobileHeader = computed(() => {
    const routeName = route?.name?.toString() ?? '';
    return !ROUTES_WITH_MOBILE_HEADER.includes(routeName);
  });
  return computed(() => isMobile.value && routeWithoutMobileHeader.value);
};
